export function getAuthorizationReturnUrl(
  rawReturnUrl: string | null,
  origin: string,
): string | null {
  if (!rawReturnUrl) return null

  try {
    const candidate = new URL(rawReturnUrl, origin)
    const expectedOrigin = new URL(origin).origin

    if (candidate.origin !== expectedOrigin) return null
    if (candidate.pathname !== '/connect/authorize') return null

    return `${candidate.pathname}${candidate.search}${candidate.hash}`
  } catch {
    return null
  }
}
